module.exports = {
	neworabkapi : {
		base_url : process.env.VUE_APP_BASE_URL_API
	}
};
